var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 60.947,
    height: 65.415,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1943",
    "data-name": "Groupe 1943",
    transform: "translate(-761 -8631)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(761 8631)",
    fill: "#d4b993"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1939",
    "data-name": "Groupe 1939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1932",
    "data-name": "Groupe 1932",
    transform: "translate(782.526 8648.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1931",
    "data-name": "Groupe 1931",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_720",
    "data-name": "Trac\\xE9 720",
    d: "M157.459,120.481a9.182,9.182,0,0,1-4.364-1.039c-2.351-1.262-3.969-3.6-4.81-6.939l-.2-.8.8-.228c3.314-.946,6.12-.7,8.34.736,3.5,2.264,4.18,6.635,4.208,6.82l.1.7-.664.234a11.114,11.114,0,0,1-3.407.523m-7.282-7.574a8.132,8.132,0,0,0,3.715,5.019,8.493,8.493,0,0,0,5.673.609,8.528,8.528,0,0,0-3.285-4.9,7.813,7.813,0,0,0-6.1-.731",
    transform: "translate(-128.574 -96.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_721",
    "data-name": "Trac\\xE9 721",
    d: "M244.141,23.626l-.164-.68c-.08-.337-1.915-8.339,2.585-14.943,2.917-4.281,7.794-6.935,14.495-7.886L261.878,0l.142.817c1.143,6.562.148,11.9-2.96,15.871-4.67,5.964-12.5,6.8-14.025,6.9-.128.009-.195.011-.195.011ZM260.467,1.941c-5.775.973-9.974,3.334-12.49,7.026-3.338,4.9-2.787,10.828-2.468,12.859,2.068-.24,8.414-1.356,12.2-6.194,2.667-3.407,3.593-8.01,2.755-13.692",
    transform: "translate(-211.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_722",
    "data-name": "Trac\\xE9 722",
    d: "M240.808,77.65a.857.857,0,0,1-.846-.728,27.216,27.216,0,0,1,.665-9.662,25.807,25.807,0,0,1,10.757-15.479.856.856,0,1,1,.961,1.417,23.806,23.806,0,0,0-10.055,14.468,25.842,25.842,0,0,0-.636,9,.857.857,0,0,1-.848.985",
    transform: "translate(-208.206 -44.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_723",
    "data-name": "Trac\\xE9 723",
    d: "M185.339,247.781a.856.856,0,0,1-.553-1.511,3.477,3.477,0,0,0,1.169-3.278,3.476,3.476,0,0,0-4.175-2.767.856.856,0,0,1-.895-.356,4.644,4.644,0,0,0-3.807-2.042h-.036a4.636,4.636,0,0,0-3.842,2.042.856.856,0,0,1-.894.356,3.477,3.477,0,0,0-4.2,2.891.856.856,0,0,1-1.695-.245,5.188,5.188,0,0,1,5.7-4.411,6.344,6.344,0,0,1,4.927-2.345h.043a6.36,6.36,0,0,1,4.885,2.345,5.188,5.188,0,0,1,5.669,4.22,5.111,5.111,0,0,1,.086.941,5.181,5.181,0,0,1-1.834,3.958.853.853,0,0,1-.552.2",
    transform: "translate(-144.482 -205.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_724",
    "data-name": "Trac\\xE9 724",
    d: "M315.206,256.34a.856.856,0,0,1-.671-1.387,16.655,16.655,0,0,0,2.826-4.6.2.2,0,0,0-.06-.216.207.207,0,0,0-.227-.042,11.97,11.97,0,0,0-3.638,2.869.856.856,0,1,1-1.235-1.187,13.087,13.087,0,0,1,4.245-3.276A1.927,1.927,0,0,1,319,250.839a17.882,17.882,0,0,1-3.126,5.176.856.856,0,0,1-.672.325",
    transform: "translate(-270.865 -215.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_725",
    "data-name": "Trac\\xE9 725",
    d: "M307.27,265.369a.856.856,0,0,1-.535-1.525c.532-.425,1.306-1.182,2.2-2.059.274-.268.56-.548.855-.834,2.551-2.472,5.223-4.848,7.483-5.5a2,2,0,0,1,2.41,2.66,16.832,16.832,0,0,1-2.108,3.306.856.856,0,0,1-1.341-1.066,15.378,15.378,0,0,0,1.859-2.876.272.272,0,0,0-.053-.294.277.277,0,0,0-.294-.084c-1.9.547-4.488,2.876-6.765,5.082-.293.284-.576.561-.849.828-.929.909-1.732,1.694-2.331,2.173a.853.853,0,0,1-.534.187",
    transform: "translate(-266.046 -221.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_726",
    "data-name": "Trac\\xE9 726",
    d: "M309.749,275.476a.856.856,0,0,1-.112-1.705c3.061-.408,4.91-1.763,8.593-4.463l.617-.452.029-.02c3.042-2.04,5.135-3.041,6.787-3.244a2,2,0,0,1,1.965,3.006c-.913,1.528-2.853,3.27-6.108,5.482a.856.856,0,1,1-.963-1.416c3-2.038,4.831-3.655,5.6-4.943a.271.271,0,0,0-.007-.3.279.279,0,0,0-.279-.13c-1.772.218-4.285,1.789-6.027,2.957l-.6.441c-3.67,2.69-5.885,4.314-9.38,4.779a.838.838,0,0,1-.114.008",
    transform: "translate(-268.2 -230.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_727",
    "data-name": "Trac\\xE9 727",
    d: "M10.793,310.831a.856.856,0,0,1-.662-1.4c.074-.091,1.841-2.244,4.129-4.552,3.147-3.174,5.658-5,7.463-5.437,2.007-.482,5.6-.5,9.406-.518,3.938-.02,8.009-.04,10.136-.591,3.319-.861,14.137-7.435,17.882-9.905a.19.19,0,0,0,.087-.181.161.161,0,0,0-.1-.144,6.331,6.331,0,0,0-3.948.065c-.669.223-1.424.556-2.3.942l-.218.1a37.744,37.744,0,0,1-8.244,2.743,35.8,35.8,0,0,1-4.184.573c-.611.048-1.238.083-1.863.1-1.277.041-2.619.024-3.988-.051-1-.055-2.038-.144-3.1-.264a.865.865,0,0,1,.079-1.725c1.06-.029,1.962-.059,2.755-.091a28.791,28.791,0,0,0,5.121-.512l.033-.007c1.173-.234,1.5-.712,1.5-.931,0-.013,0-.031,0-.047a.61.61,0,0,0-.142-.17,8.477,8.477,0,0,0-2.939-1.289c-1.56-.467-3.473-.895-5.324-1.309-1.318-.295-2.564-.573-3.7-.866-5.068-1.31-8.013-1.323-10.864-.047-1.476.66-5.267,4.1-8.612,7.139-3.257,2.957-6.334,5.751-7.93,6.657a.856.856,0,1,1-.846-1.489c1.431-.813,4.58-3.671,7.625-6.436,3.774-3.426,7.338-6.662,9.063-7.434,3.25-1.454,6.5-1.467,11.992-.047,1.106.286,2.338.561,3.642.853,1.88.42,3.824.855,5.441,1.339a9.513,9.513,0,0,1,3.607,1.67,1.864,1.864,0,0,1,.69,1.557,2.334,2.334,0,0,1-.74,1.524c.8-.1,1.577-.226,2.337-.378a35.725,35.725,0,0,0,7.888-2.63l.217-.1c.915-.4,1.7-.751,2.449-1a8.006,8.006,0,0,1,5.178-.009A1.883,1.883,0,0,1,60.94,288.1a1.908,1.908,0,0,1-.85,1.755c-3.433,2.265-14.626,9.156-18.4,10.133-2.334.6-6.514.625-10.557.646-3.54.017-7.2.036-9.015.471-3.031.727-8.727,7.038-10.667,9.408a.855.855,0,0,1-.663.314m20.6-18.531h0Zm.02,0h0Zm0,0h0Zm9.374-3.314h0",
    transform: "translate(0 -245.416)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.71c3a7b50b8543a54eac1ba6679f128b.svg";
export { ForwardRef as ReactComponent };